export default function({ state, commit, dispatch }, schedule) {
    commit('startSchedulingPatient', schedule.patient)

    return dispatch('delete', {
        url: '/provider/' + (state.id ? state.id : schedule.provider) + '/patient/' + schedule.patient + '/schedule/' + schedule.id
    }, {
        root: true
    })
    .then((response) => {
        commit('finishSchedulingPatient', schedule.patient)
        commit('removePatientSchedule', schedule)
		return response
    })
    .catch((error) => {
        commit('finishSchedulingPatient', schedule.patient)
		throw error
    })
}
